import { HARDCODED_DATA_KEY } from "src/stores/models/data-key";
import { PrePromptTransformerConfig } from "@types";
import { parseMarkdownTable } from "@utils";

export const dataKeyToPrePromptTransformerConfig: Record<
  string,
  PrePromptTransformerConfig
> = {
  [HARDCODED_DATA_KEY.CLINICAL_TRIAL_SEARCH_TABLE]: {
    inputs: [HARDCODED_DATA_KEY.CLINICAL_TRIAL_SEARCH_TABLE_RAW_CSV],
    transformer: (inputs: Record<string, string>) => {
      const clinicalTrials = JSON.parse(
        inputs[HARDCODED_DATA_KEY.CLINICAL_TRIAL_SEARCH_TABLE_RAW_CSV]
      );

      const filteredTable: Record<string, unknown>[] = clinicalTrials.map(
        (trial: any) => ({
          id: trial.id,
          title: trial.title,
          description: trial.description,
          outcomes: trial.outcomes,
          conditions: trial.conditions,
        })
      );

      return [
        {
          id: HARDCODED_DATA_KEY.CLINICAL_TRIAL_SEARCH_TABLE_RAW_CSV,
          value: JSON.stringify(filteredTable),
        },
      ];
    },
  },
  [HARDCODED_DATA_KEY.CLINICAL_TRIALS_INDIVIDUAL_SUMMARY]: {
    inputs: [
      HARDCODED_DATA_KEY.CLINICAL_TRIAL_SEARCH_TABLE_RAW_CSV,
      HARDCODED_DATA_KEY.CLINICAL_TRIAL_SEARCH_TABLE,
    ],
    transformer: (inputs: Record<string, string>) => {
      const clinicalTrials = JSON.parse(
        inputs[HARDCODED_DATA_KEY.CLINICAL_TRIAL_SEARCH_TABLE_RAW_CSV]
      );
      const clinicalTrialsSearchTable = parseMarkdownTable(
        inputs[HARDCODED_DATA_KEY.CLINICAL_TRIAL_SEARCH_TABLE]
      );

      if (
        !clinicalTrials.every((trial: Record<string, unknown>) =>
          clinicalTrialsSearchTable.find((row) => row["Trial ID"] === trial.id)
        )
      ) {
        throw new Error(
          "The clinical trials identified in your the table do not match the clinical trials JSON file that you uploaded in the previous step. Please return to the file upload screen and upload the correct JSON file and then reload the table on the next screen to correct this issue. If the issue persists please contact us."
        );
      }

      const filteredTable: Record<string, unknown>[] = clinicalTrials.filter(
        (trial: Record<string, unknown>) =>
          clinicalTrialsSearchTable.some(
            (row) =>
              row["Trial ID"] === trial.id &&
              row["Relevant"].toLowerCase().trim() === "relevant"
          )
      );

      return [
        {
          id: HARDCODED_DATA_KEY.CLINICAL_TRIAL_SEARCH_TABLE_RAW_CSV,
          value: JSON.stringify(filteredTable),
        },
      ];
    },
  },
};
